import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.color ? props.color : '#fff')};

  .left { font-size: 4.5rem; }
  .right {
    display: flex;
    flex-direction: column;
    font-size: 1.7rem;
    font-weight: 700;
    margin-left: 0.2rem;

    p {
      margin: 0;

      &:last-of-type { margin-top: -0.5rem !important; }
    }
  }
`;

const PhoneNumber = ({ color }) => (
  <Wrapper color={color}>
    <div className="left">1300</div>
    <div className="right">
      <p>QLEGAL</p>
      <p>753425</p>
    </div>
  </Wrapper>
);

export default PhoneNumber;



// WEBPACK FOOTER //
// ./src/components/PhoneNumber/index.js